// Onboarding sections that exist in the code but are switched off pending
// rework. Ported from the design repo's src/config/flags.ts, where the rule is
// the same: filter, never delete, so turning one back on is a one-line change
// rather than a re-implementation.

/**
 * Books questions' "Catch-up accounting" bookkeeping-start option.
 *
 * Off because catch-up has no distinct handling downstream yet: choosing it
 * only backdates the start date a year, which "Existing Zoho Books" plus an
 * earlier start date already does, without implying we have a catch-up
 * workflow. The option and its wiring stay so it can come back with one.
 */
export const SHOW_CATCHUP_BOOKKEEPING = false;
